import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "chat-container"
};
var _hoisted_2 = {
  class: "chat-messages"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  key: 1,
  class: "avatar L",
  alt: ""
};
var _hoisted_5 = ["src"];
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  key: 1,
  controls: ""
};
var _hoisted_8 = ["src"];
var _hoisted_9 = ["src"];
var _hoisted_10 = ["src"];
var _hoisted_11 = ["onClick"];
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = {
  key: 1,
  class: "chatstart"
};
var _hoisted_14 = {
  class: "chatstart_top"
};
var _hoisted_15 = {
  class: "chatstart_top_model"
};
var _hoisted_16 = {
  class: "chatstart_top_model_customquestion"
};
var _hoisted_17 = ["onClick"];
import { nextTick, reactive, ref, onBeforeUnmount } from "vue";
// 引入 marked 库
import { marked } from "marked";
import aiinput from "@/views/instant_messages/components/aiinput.vue";
import { useUserStore } from '@/store/user';
import { ElMessage } from 'element-plus';
export default {
  __name: 'aiquestion',
  setup(__props) {
    var userStore = useUserStore();
    var placeholder_txt = ref("请输入你想问的问题...");
    var cutomquestions = [{
      question: '今天天气怎么样'
    }, {
      question: '怎么高效的完成工作'
    }, {
      question: '报销流程怎么看'
    }];
    var messages = ref([]);
    console.log("process-->", process.env.NODE_ENV);
    var wss_ = reactive({
      event_source: null,
      url: process.env.NODE_ENV == 'development' ? 'wss://www.bio-cloud.com.cn:8121' : 'wss://www.bio-cloud.com.cn:8120',
      conversation_id: '',
      //会话id
      file_ids: '' //会话过程中上传的文件的file_id
    });
    var result = ref('');
    // wss_.url = process.env.VUE_APP_BASE_URL + '/wss_'
    wss_.event_source = new WebSocket(wss_.url);

    // 连接socket
    wss_.event_source.onopen = evt => {
      console.log('websocket已连接', evt);
    };

    // 获取socket传来的数据
    wss_.event_source.onmessage = evt => {
      console.log("evt-->", evt);
      if (evt.data && evt.data != '\n') {
        var reponses = JSON.parse(evt.data);
        console.log("response--->", reponses);
        if (reponses.code != 200) {
          ElMessage({
            type: 'error',
            message: reponses.msg
          });
          messages.value[messages.value.length - 1] = {
            type: "bot",
            text: '生成失败！'
          };
          result.value = '';
          placeholder_txt.value = "请输入你想问的问题...";
          return false;
        }
        var answer = reponses.answer;
        if (answer && answer != '\n') {
          if (answer.answer) {
            result.value = answer.answer;
            // result.value = result.value + answer.answer;
            console.log("result.value-->", result.value);
            // 对返回结果中的markdown转换为html  
            // let html = marked(result.value, { sanitize: true });
            messages.value[messages.value.length - 1] = {
              type: "bot",
              text: result.value
            };
            scrollToBottom();
          }
          if (answer.is_completion == true) {
            var _reponses$data;
            // 此时存储一下会话id 以及file_id发给后端
            wss_.conversation_id = reponses === null || reponses === void 0 || (_reponses$data = reponses.data) === null || _reponses$data === void 0 ? void 0 : _reponses$data.conversation_id;
            if (reponses.data && reponses.data.file_ids && reponses.data.file_ids[0]) {
              wss_.file_ids = reponses.data.file_ids[0];
            }
            result.value = '';
            placeholder_txt.value = "请输入你想问的问题...";
          }
        }
      }
    };

    //监听webscoket关闭事件
    wss_.event_source.onclose = e => {
      console.log("websocket已关", e);
      wss_.event_source.open = evt => {
        console.log('websockety已连接', evt);
      };
    };

    //监听websocket连接错误事件
    wss_.event_source.onerror = e => {
      console.log("websocket发生错误->", e);
    };
    onBeforeUnmount(() => {
      // 组件销毁时关闭socket
      wss_.event_source.close();
    });

    // 消息页面滚动到底部
    function scrollToBottom() {
      var chatMessages = document.querySelector(".chat-messages");
      nextTick(() => {
        if (!chatMessages) return;
        chatMessages.scrollTop = chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages.scrollHeight;
      });
    }
    // 发送消息
    var handle_sendmessage = (value, file) => {
      console.log("value->", value, 'file-->', file);
      placeholder_txt.value = "正在回答问题中...";
      messages.value.push({
        type: "user",
        text: value,
        file: file
      });
      messages.value.push({
        type: "bot",
        text: '开始生成...'
      });
      scrollToBottom();
      if (value || file && file.file_url) {
        // 检查websokcet连接已开
        if (wss_.event_source && wss_.event_source.readyState === WebSocket.OPEN) {
          // 区分发送消息的类型
          var type = 'question';
          if (file && file.question_type) {
            type = file.question_type;
          }
          var data = {
            type: type,
            question: value
          };
          if (file && file.file_url) {
            data.file_url = file.file_url;
          }
          if (wss_.conversation_id && (type == 'image' || type == 'translate')) {
            data['conversation_id'] = wss_.conversation_id;
          }
          if (wss_.file_ids && (type == 'image' || type == 'translate')) {
            data['file_ids'] = wss_.file_ids;
          }
          var message = JSON.stringify({
            event: 'AI',
            data: data,
            from: userStore.info.id,
            to: 0
          });
          console.log("message--->", message);
          // 发送问题到服务器             
          wss_.event_source.send(message);
        }
      }
    };
    // 预览
    var handle_link = url => {
      var a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.click();
    };

    // 问常问问题
    var handle_askcustom_question = v => {
      handle_sendmessage(v.question);
    };
    return (_ctx, _cache) => {
      var _directive_highlight = _resolveDirective("highlight");
      return messages.value && messages.value[0] ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
        var _message$file, _message$file2, _message$file3, _message$file4;
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass({
            'modelmessage': true,
            'isuser': message.type === 'user'
          }),
          key: index
        }, [_createElementVNode("div", null, [message.type === 'user' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "avatar R",
          src: _unref(userStore).info.avatar,
          alt: ""
        }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("img", {
          class: "loading",
          src: _unref(placeholder_txt) == '正在回答问题中...' && index == messages.value.length - 1 ? 'https://www.bio-cloud.com.cn:8022/icon/loading.gif' : 'https://www.bio-cloud.com.cn:8022/icon/ai_logo.png',
          alt: ""
        }, null, 8, _hoisted_5)]))]), _createElementVNode("div", {
          class: _normalizeClass({
            'txthtml': true,
            'txt_l': message.type != 'user',
            'txt_r': message.type === 'user'
          })
        }, [(message === null || message === void 0 || (_message$file = message.file) === null || _message$file === void 0 ? void 0 : _message$file.type) == 'image' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "txthtml_img",
          src: message.file.file_url,
          alt: ""
        }, null, 8, _hoisted_6)) : _createCommentVNode("", true), (message === null || message === void 0 || (_message$file2 = message.file) === null || _message$file2 === void 0 ? void 0 : _message$file2.type) == 'audio' ? (_openBlock(), _createElementBlock("audio", _hoisted_7, [_createElementVNode("source", {
          src: message.file.file_url,
          type: "audio/ogg"
        }, null, 8, _hoisted_8), _createElementVNode("source", {
          src: message.file.file_url,
          type: "audio/mpeg"
        }, null, 8, _hoisted_9), _createElementVNode("source", {
          src: message.file.file_url,
          type: "audio/wav"
        }, null, 8, _hoisted_10), _cache[0] || (_cache[0] = _createTextVNode(" 您的浏览器不支持 audio 元素。 "))])) : _createCommentVNode("", true), (message === null || message === void 0 || (_message$file3 = message.file) === null || _message$file3 === void 0 ? void 0 : _message$file3.type) == 'file' || (message === null || message === void 0 || (_message$file4 = message.file) === null || _message$file4 === void 0 ? void 0 : _message$file4.type) == 'audio' ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: "txthtml_link",
          onClick: $event => handle_link(message.file.file_url)
        }, _toDisplayString(message.file.name), 9, _hoisted_11)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
          innerHTML: message.text
        }, null, 8, _hoisted_12), [[_directive_highlight]])], 2)], 2);
      }), 128))]), _createVNode(aiinput, {
        onHandle_sendmessage: handle_sendmessage,
        placeholder_txt: _unref(placeholder_txt)
      }, null, 8, ["placeholder_txt"])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[2] || (_cache[2] = _createElementVNode("img", {
        class: "chatstart_top_img",
        src: "https://www.bio-cloud.com.cn:8022/icon/bio_person.png",
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_15, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "猜你想问...", -1)), _createElementVNode("div", _hoisted_16, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(cutomquestions, (v, i) => {
        return _createElementVNode("div", {
          class: "chatstart_top_model_customquestion_question",
          onClick: $event => handle_askcustom_question(v),
          key: i
        }, _toDisplayString(v.question), 9, _hoisted_17);
      }), 64))])])]), _createVNode(aiinput, {
        class: "boxs",
        onHandle_sendmessage: handle_sendmessage,
        placeholder_txt: _unref(placeholder_txt)
      }, null, 8, ["placeholder_txt"])]));
    };
  }
};